var mouse = "https://shopfront-cdn.tekoapis.com/static/56345fd3fd3da76d.svg";

export { mouse as default };
